/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotPlayableCircle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m18.329 19.743 3.964 3.964 1.414-1.414-22-22L.293 1.707l3.964 3.964A9.959 9.959 0 0 0 2 12c0 5.523 4.477 10 10 10a9.958 9.958 0 0 0 6.329-2.257zm-1.423-1.423A8 8 0 0 1 5.68 7.094l3.933 3.934V16l3.164-1.808zM22 12a9.953 9.953 0 0 1-1.649 5.503L18.9 16.05A8 8 0 0 0 7.949 5.1L6.497 3.65A9.953 9.953 0 0 1 12 2c5.523 0 10 4.477 10 10z" />
        <path d="m16.613 12-1.123.642-2.995-2.995z" />
      </g>
    </g>
  </Icon>
);
export { SvgNotPlayableCircle as NotPlayableCircle };
